import React, { useEffect } from "react";
import "./ClubsActivity.css";
import { Clubscard,Backtotop,Modal, Underline,Videocard,ContentCard } from "../../widgets";
import { Heroimagecarousal,Slideshow } from "../../components";
import { Clubs_info ,clubs_heroimage_carousalinfo,Clubs_heroimage_carousalinfo,Club_Activity,Music_Club_Activity} from "../../constants/Clubs";
const ClubsActivity = () => {
  useEffect(() => {
    document.title = "ACCET | Club Activity";
  }, []);

  return (
   <div>
         <Backtotop/>
         
   
       <div className="alumni_body_clubs">
           
            
                    {/*<Slideshow images={slideshow_imgs_club} />*/}
                    <Heroimagecarousal
          key={clubs_heroimage_carousalinfo.id}
          title={clubs_heroimage_carousalinfo.title}
          img_list={clubs_heroimage_carousalinfo.img_list}
        />
           <div className="container clubs-menu_clubs">
             <a href="/Clubs" className="lin_clubs">
               About
             </a>
             {/* <a href="#contribution" className="lin">
               Contributions
             </a> */}
             <a href="/Clubs/ClubsActivity" className="lin_clubs">
               Club Activity Reports
             </a>
           </div>
           </div>
            <div className="divider_clubs"></div>
           
                   <div className="about_clubs">
                     <p className="heading_clubs" id="about">
                       <Underline heading="Club Reports" />
                     </p>
                     </div>
           <section className="clubs_activity_dark">
        <div className="club_activity_records">
          
            {Club_Activity.map((item) => (
              <ContentCard
                key={item.id}
                heading={item.program}
                pdf={item.pdf}
              />
            ))}
        </div>
      </section>
      <div className="about_clubs">
                     <p className="heading_clubs" id="about">
                       <Underline heading="Music Club Reports" />
                     </p>
                     </div>
           <section className="clubs_activity_dark">
        <div className="club_activity_records">
          
            {Music_Club_Activity.map((item) => (
              <ContentCard
                key={item.id}
                heading={item.program}
                pdf={item.pdf}
              />
            ))}
        </div>
      </section>
        
           </div>
  );
};

export default ClubsActivity;